const summaryColors = [
  { pct: 0.0, color: { r: 0xe5, g: 0x56, b: 0xa5 } },
  { pct: 0.5, color: { r: 0xff, g: 0xff, b: 0xff } },
  // keltainen { pct: 0.5, color: { r: 0xf8, g: 0xff, b: 0x8d } },
  { pct: 1.0, color: { r: 0x8d, g: 0xff, b: 0xc2 } }
]

// eslint-disable-next-line
export { summaryColors }
